import React, { useContext} from 'react';
import * as PropTypes from 'prop-types';
import styles from './styles.modules.scss';
import Popover from 'ati-ui-react/components/Tip/Popover';
import Link from 'ati-ui-react/components/Link';
import PlusSolid from 'ati-ui-react/components/icons/PlusSolid';

import {DataContext} from 'contexts';
import {isUsersParticipateOrInvited} from './utils';
import BoardRow from './BoardRow';
import {useLocalized} from 'utils/useLocalized';
import i18nStrings from './strings';
import Button from 'ati-ui-react/components/Button/v3';
import PlainText from 'ati-ui-react/components/PlainText';
import CheckThin from 'ati-ui-react/components/icons/CheckThin';
import {mainSiteUrl} from 'urls';


const BoardsListPopover = ({atiIds, boards, children, saved, visible, onInvite, onVisibilityChange, onBoardSelectToggle}) => {
    const { isMobile } = useContext(DataContext);
    const strings = useLocalized(i18nStrings);

    const onInviteClick = ()=> {
        const boardsToInvite = boards.filter(b=>!isUsersParticipateOrInvited(b, atiIds) && b.checked).map(b=>b.id);
        if(boardsToInvite?.length){
            onInvite(boardsToInvite);
        }
    };

    return (
        <Popover
            isClosedOnOutsideClick
            restorePosition
            control={(
                <div className={styles['popup-footer']}>
                    <Button
                        disabled={!boards || !boards.filter(b=>!isUsersParticipateOrInvited(b, atiIds) && b.checked).length}
                        mobile={true}
                        size="small"
                        onClick={onInviteClick}
                    >
                        {strings.invite}
                    </Button>
                    {saved && (
                        <PlainText
                            secondary
                            className={styles['saved']}
                            size="small"
                        >
                            <CheckThin
                                color="#64B82A"
                                height="10px"
                            />
                            {strings.saved}
                        </PlainText>
                    )}
                </div>
            )}
            fixedBodyPosition={isMobile}

            isCenterAlignmentOnAdaptive={false}
            mainContent={(

                <React.Fragment>
                    <div
                        className={styles['popover-header']}
                    >
                        <span>
                            {strings.chooseBoards}
                        </span>
                    </div>
                    <div className={styles['main-content']}>
                        {boards.map(b=> {
                            return (
	                            <BoardRow
		                            atiIds={atiIds}
		                            board={b}
		                            key={b.id}
		                            onBoardToggle={onBoardSelectToggle}
	                            />
                            );
                        })}
                    </div>
                    <div className={styles['footer-content']}>
                        <Link
                            before={(
                                <PlusSolid
                                    height="16"
                                    width="16"
                                />
                            )}
                            href={`${mainSiteUrl}/boards/my/add/loads`}
                            target="_blank"
                        >
                            <span>
                                {strings.createBoards}
                            </span>
                        </Link>
                    </div>
                </React.Fragment>
            )}
            mainContentClassName={styles['content-section']}
            placement="top"
            templateWrapperClassName={styles['popover-container']}
            visible={visible}

            onCloseClick={(event)=>onVisibilityChange(false, event)}
            onVisibilityChange={onVisibilityChange}
        >
            <div
                onClick={() => {
                    onVisibilityChange(true);
                }}
            >
                {children}
            </div>
        </Popover>
    );
};

export default BoardsListPopover;

BoardsListPopover.propTypes = {
    atiIds: PropTypes.arrayOf(PropTypes.string),
    boards: PropTypes.array,
    children: PropTypes.node,
    saved: PropTypes.bool,
    visible: PropTypes.bool,
    onBoardSelectToggle: PropTypes.func,
    onInvite: PropTypes.func,
    onVisibilityChange: PropTypes.func,
};
